/**
 * Am I running inside the desktop shell?
 *
 * A leaf on purpose. This predicate is asked by modules far below the desktop feature — most
 * importantly `features/onboarding/deploymentAddress.ts`, which decides where the app talks — and
 * `desktopRuntime.ts` cannot answer for them: it imports the attachment API, which imports
 * `ApiService`, which imports `deploymentAddress`. Asking the question from there would close that
 * loop, and `ApiService` computes its base URL at module load, so a cycle would be a value read
 * before it is written rather than a warning in a build log.
 *
 * It therefore imports nothing, and it is the single place the question is answered — duplicating
 * the check would leave two definitions of "desktop" free to drift apart.
 */
export function isDesktopRuntime(): boolean {
  return (
    typeof window !== 'undefined' &&
    (window.isTauri === true || window.__TAURI_INTERNALS__ !== undefined)
  );
}
